<main class="pin-stage" *ngIf="stage === 'pin'">
  <div class="pin-stage__image"></div>
  <div class="pin-stage__card">
    <img class="img-logo" src="../../../assets/MIV/brand/versao 1.png" alt="Control PS" />
    <h2>Entre para continuar</h2>
    <p>Use o token de seis dígitos enviado por e-mail.</p>
    <form (ngSubmit)="submitPin()" [formGroup]="pinForm" class="pin-form">
      <mat-form-field appearance="outline" class="pin-input">
        <mat-label>Token</mat-label>
        <input matInput formControlName="pin" maxlength="6" autocomplete="off" />
      </mat-form-field>
      <button mat-raised-button color="primary" type="submit" [disabled]="pinForm.invalid">
        Confirmar
      </button>
    </form>
    <span class="error" *ngIf="errorMessage">{{ errorMessage }}</span>
  </div>
</main>

<section class="form-stage" *ngIf="(stage === 'form' || stage === 'documents') && admissions">
  <header class="form-stage__topbar">
    <div class="form-stage__brand">
      <img class="form-stage__logo" src="../../../assets/MIV/brand/versao 1.png" alt="Control PS" />
      <div class="form-stage__brand-text">
        <span>ControlDP</span>
        <strong>Admissão Digital</strong>
      </div>
    </div>

    <div class="form-stage__topbar-metas">
      <div class="form-stage__meta">
        <mat-icon>event</mat-icon>
        <span>{{ currentDateLabel }}</span>
      </div>
      <div class="form-stage__meta">
        <mat-icon>schedule</mat-icon>
        <span>{{ currentTimeLabel }}</span>
      </div>
    </div>

    <div class="form-stage__profile">
      <div class="form-stage__profile-text">
        <span class="form-stage__greeting">Olá, {{ admissions.header.full_name || 'Colaborador' }}</span>
        <small>{{ admissions.header.personal_email || 'Cadastro individual' }}</small>
      </div>
      <span class="form-stage__avatar">{{ initialsFromName(admissions.header.full_name) }}</span>
    </div>
  </header>

  <section class="form-stage__hero">
    <p class="form-stage__eyebrow">ControlPS / ControlDP</p>
    <div class="form-stage__hero-row">
      <div>
        <h2>{{ stageTitle() }}</h2>
        <p>{{ stageDescription() }}</p>
      </div>
      <div class="form-stage__hero-right">
        <button
          type="button"
          class="form-stage__review-btn"
          [disabled]="isSaving || submissionFeedbackState === 'loading' || isAdmissionUnderReview"
          (click)="openReviewModal()">
          {{ isAdmissionUnderReview ? 'Cadastro enviado' : 'Revisar e enviar cadastro' }}
        </button>
        <span class="form-stage__stage-pill">{{ stageLabel(stage === 'documents' ? 'documents' : 'form') }}</span>
      </div>
    </div>
    <div class="form-stage__steps">
      <button type="button" class="form-stage__step-btn" [class.active]="stage === 'form'" (click)="goToFormStage()">
        1. Dados pessoais
      </button>
      <button type="button" class="form-stage__step-btn" [class.active]="stage === 'documents'" (click)="goToDocumentsStage()">
        2. Documentos
      </button>
    </div>
    <div class="form-stage__progress">
      <span>{{ activeProgressPercentage }}% preenchido</span>
      <div class="form-stage__progress-track">
        <div class="form-stage__progress-value" [style.width.%]="activeProgressPercentage"></div>
      </div>
    </div>
  </section>

  <section class="form-stage__workspace">
    <aside class="form-stage__summary">
      <div class="form-stage__summary-head">
        <h3>Resumo do cadastro</h3>
        <button
          type="button"
          class="form-stage__summary-toggle"
          (click)="toggleMobileSummary()"
          [attr.aria-expanded]="isMobileSummaryOpen">
          {{ isMobileSummaryOpen ? 'Ocultar' : 'Ver resumo' }}
        </button>
      </div>
      <div class="form-stage__info" [class.form-stage__info--collapsed-mobile]="!isMobileSummaryOpen">
        <div class="form-stage__info-item">
          <span class="form-stage__info-label">Nome</span>
          <span class="form-stage__info-value">{{ admissions.header.full_name || '-' }}</span>
        </div>
        <div class="form-stage__info-item">
          <span class="form-stage__info-label">CPF</span>
          <span class="form-stage__info-value">{{ admissions.header.cpf || '-' }}</span>
        </div>
        <div class="form-stage__info-item">
          <span class="form-stage__info-label">E-mail</span>
          <span class="form-stage__info-value">{{ admissions.header.personal_email || '-' }}</span>
        </div>
        <div class="form-stage__info-item">
          <span class="form-stage__info-label">Acessado em</span>
          <span class="form-stage__info-value">{{ formatDateTime(admissions.header.accessed_at) }}</span>
        </div>
        <div class="form-stage__info-item">
          <span class="form-stage__info-label">Expira em</span>
          <span class="form-stage__info-value">{{ formatDateTime(admissions.header.expires_at) }}</span>
        </div>
        <div class="form-stage__info-item" *ngIf="admissions.header.hired_at">
          <span class="form-stage__info-label">Admissão prevista</span>
          <span class="form-stage__info-value">{{ formatDateTime(admissions.header.hired_at) }}</span>
        </div>
      </div>
    </aside>

    <div class="form-stage__card">
      <form *ngIf="stage === 'form'; else documentsStageContent" [formGroup]="detailsForm" (ngSubmit)="saveDetails()" class="form-stage__fields">
        <div class="form-stage__photo-field">
          <input #photoInput type="file" accept="image/*" hidden [disabled]="isAdmissionUnderReview" (change)="onPhotoSelected($event)" />
          <div
            class="form-stage__photo-dropzone"
            [class.dragging]="isPhotoDragging"
            [class.readonly]="isAdmissionUnderReview"
            (click)="openPhotoPicker(photoInput)"
            (dragover)="onPhotoDragOver($event)"
            (dragleave)="onPhotoDragLeave($event)"
            (drop)="onPhotoDrop($event)">
            <ng-container *ngIf="photoPreviewUrl; else emptyPhoto">
              <img [src]="photoPreviewUrl" alt="Foto do colaborador" />
            </ng-container>
            <ng-template #emptyPhoto>
              <mat-icon>add_a_photo</mat-icon>
              <strong>Adicione a foto do colaborador</strong>
              <span>Arraste e solte ou clique para selecionar</span>
            </ng-template>
          </div>
          <div class="form-stage__photo-actions">
            <button type="button" class="photo-action photo-action--primary" [disabled]="isAdmissionUnderReview" (click)="openPhotoPicker(photoInput)">
              Selecionar foto
            </button>
            <button type="button" class="photo-action" *ngIf="photoPreviewUrl" [disabled]="isAdmissionUnderReview" (click)="removePhoto()">
              Remover
            </button>
          </div>
          <small>JPG ou PNG, até 5MB.</small>
        </div>

        <div class="form-stage__group-title">Dados pessoais</div>

        <mat-form-field appearance="outline">
          <mat-label>RG</mat-label>
          <input matInput formControlName="rg" maxlength="20" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-admission-date-field">
          <mat-label>Data de nascimento</mat-label>
          <input
            matInput
            formControlName="birth_date"
            placeholder="dd/mm/aaaa"
            (input)="onDateInputMask('birth_date', $event)"
            (blur)="onDateInputBlur('birth_date')" />
          <input
            class="form-stage__datepicker-proxy"
            matInput
            [matDatepicker]="birthDatePicker"
            (dateChange)="onDatepickerChange('birth_date', $event)"
            tabindex="-1"
            aria-hidden="true" />
          <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #birthDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Local de nascimento</mat-label>
          <mat-select formControlName="birth_location">
            <mat-option value="">Selecione</mat-option>
            <mat-option *ngFor="let location of birthLocationOptions" [value]="location">{{ location }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Raça/Cor</mat-label>
          <mat-select formControlName="race">
            <mat-option value="">Selecione</mat-option>
            <mat-option *ngFor="let option of raceOptions" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Gênero</mat-label>
          <mat-select formControlName="gender">
            <mat-option *ngFor="let option of genderOptions" [value]="option.value">{{ option.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Estado civil</mat-label>
          <mat-select formControlName="marital_status">
            <mat-option value="">Selecione</mat-option>
            <mat-option *ngFor="let status of maritalStatusOptions" [value]="status">{{ status }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Nome da mãe</mat-label>
          <input matInput formControlName="mother_name" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Nome do pai</mat-label>
          <input matInput formControlName="father_name" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Escolaridade</mat-label>
          <mat-select formControlName="education_level">
            <mat-option value="">Selecione</mat-option>
            <mat-option *ngFor="let level of educationLevelOptions" [value]="level">{{ level }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="form-stage__group-title">Contatos</div>

        <mat-form-field appearance="outline">
          <mat-label>Telefone</mat-label>
          <input matInput formControlName="phone" maxlength="15" placeholder="(00) 00000-0000" (input)="onPhoneInput('phone')" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Contato de emergência</mat-label>
          <input matInput formControlName="emergency_contact_name" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Telefone de emergência</mat-label>
          <input
            matInput
            formControlName="emergency_contact_phone"
            maxlength="15"
            placeholder="(00) 00000-0000"
            (input)="onPhoneInput('emergency_contact_phone')" />
        </mat-form-field>

        <div class="form-stage__group-title">Endereço</div>

        <mat-form-field appearance="outline">
          <mat-label>CEP</mat-label>
          <input matInput formControlName="cep" maxlength="9" placeholder="00000-000" (input)="onCepInput()" (blur)="onCepBlur()" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Rua</mat-label>
          <input matInput formControlName="street" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Número</mat-label>
          <input matInput formControlName="number" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Complemento</mat-label>
          <input matInput formControlName="complement" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Bairro</mat-label>
          <input matInput formControlName="neighborhood" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Cidade</mat-label>
          <input matInput formControlName="city" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Estado</mat-label>
          <input matInput formControlName="state" maxlength="2" placeholder="UF" (input)="onStateInput()" />
        </mat-form-field>

        <div class="form-stage__actions">
          <button mat-raised-button color="primary" type="submit" [disabled]="isSaving || isAdmissionUnderReview">
            {{ isSaving ? 'Atualizando...' : 'Atualizar dados' }}
          </button>
          <button type="button" class="form-stage__next-btn" [disabled]="isSaving || isAdmissionUnderReview" (click)="saveAndContinueToDocuments()">
            Salvar e ir para documentos
          </button>
        </div>
      </form>

      <ng-template #documentsStageContent>
        <section class="documents-stage">
          <div class="documents-stage__header">
            <h3>Documentos da admissão</h3>
            <p>
              Envie os arquivos por categoria. Total atual: {{ totalUploadedDocuments }} documento(s).
              Obrigatórios enviados: {{ requiredDocumentsFilledCount }}/{{ requiredDocumentCategories.length }}.
            </p>
          </div>

          <div class="documents-stage__status documents-stage__status--error" *ngIf="documentsError">
            {{ documentsError }}
          </div>
          <div class="documents-stage__status" *ngIf="isLoadingDocuments">Carregando documentos...</div>

          <div class="documents-stage__grid" *ngIf="!isLoadingDocuments">
            <article class="documents-stage__category" *ngFor="let category of documentCategories">
              <div
                class="documents-stage__category-header"
                [class.dragging]="draggingCategory === category.key"
                (dragover)="onDocumentDragOver($event, category.key)"
                (dragleave)="onDocumentDragLeave($event, category.key)"
                (drop)="onDocumentDrop($event, category.key)">
                <div>
                  <h4>{{ category.label }}</h4>
                  <small>{{ category.helper }} Arraste e solte aqui ou use o botão.</small>
                </div>
                <input #documentInput type="file" hidden [disabled]="isAdmissionUnderReview" (change)="onDocumentSelected($event, category.key)" />
                <button
                  type="button"
                  class="documents-stage__upload-btn"
                  [disabled]="uploadingCategory === category.key || isAdmissionUnderReview"
                  (click)="openDocumentPicker(documentInput)">
                  {{ uploadingCategory === category.key ? 'Enviando...' : 'Adicionar arquivo' }}
                </button>
              </div>

              <ul class="documents-stage__list" *ngIf="documentsByCategory[category.key].length; else emptyCategoryList">
                <li *ngFor="let file of documentsByCategory[category.key]; trackBy: trackDocumentById">
                  <button type="button" class="documents-stage__file-main" (click)="openDocumentPreview(file)">
                    <strong>{{ file.name }}</strong>
                    <span>{{ formatFileSize(file.file_size) }} • {{ formatUploadedAt(file.uploaded_at) }}</span>
                  </button>
                  <div class="documents-stage__file-actions">
                    <a
                      *ngIf="!canPreviewDocument(file)"
                      class="documents-stage__open-link"
                      [href]="documentUrl(file)"
                      target="_blank"
                      rel="noopener">
                      Abrir
                    </a>
                    <button
                      *ngIf="canPreviewDocument(file)"
                      type="button"
                      class="documents-stage__preview-btn"
                      (click)="openDocumentPreview(file)">
                      Visualizar
                    </button>
                    <button
                      type="button"
                      class="documents-stage__remove-btn"
                      [disabled]="deletingFileId === file.id || isAdmissionUnderReview"
                      (click)="removeDocument(category.key, file)">
                      {{ deletingFileId === file.id ? 'Removendo...' : 'Remover' }}
                    </button>
                  </div>
                </li>
              </ul>

              <ng-template #emptyCategoryList>
                <p class="documents-stage__empty">Nenhum arquivo enviado nesta categoria.</p>
              </ng-template>
            </article>
          </div>

          <section class="documents-stage__preview" *ngIf="previewFile">
            <div class="documents-stage__preview-header">
              <div>
                <strong>{{ previewFile.name }}</strong>
                <span>{{ formatFileSize(previewFile.file_size) }} • {{ formatUploadedAt(previewFile.uploaded_at) }}</span>
              </div>
              <div class="documents-stage__preview-actions">
                <a class="documents-stage__open-link" [href]="documentUrl(previewFile)" target="_blank" rel="noopener">Abrir em nova aba</a>
                <button type="button" class="documents-stage__close-preview-btn" (click)="closeDocumentPreview()">Fechar</button>
              </div>
            </div>
            <div class="documents-stage__preview-body" *ngIf="isImageDocument(previewFile)">
              <img [src]="documentUrl(previewFile)" [alt]="previewFile.name" />
            </div>
            <div class="documents-stage__preview-body documents-stage__preview-body--pdf" *ngIf="isPdfDocument(previewFile)">
              <iframe [src]="documentUrl(previewFile)" title="Pré-visualização de documento PDF"></iframe>
            </div>
            <div class="documents-stage__preview-body documents-stage__preview-body--empty" *ngIf="!canPreviewDocument(previewFile)">
              <p>Pré-visualização não disponível para este arquivo.</p>
            </div>
          </section>

          <div class="documents-stage__actions">
            <button type="button" class="documents-stage__secondary-btn" (click)="goToFormStage()">Voltar para dados pessoais</button>
            <button type="button" class="documents-stage__primary-btn" (click)="loadDocuments(true)">Atualizar lista</button>
          </div>
        </section>
      </ng-template>
    </div>
  </section>
</section>

<section class="admission-review-modal" *ngIf="showReviewModal && admissions">
  <div class="admission-review-modal__backdrop" (click)="closeReviewModal()"></div>
  <div class="admission-review-modal__dialog" role="dialog" aria-modal="true">
    <header class="admission-review-modal__header">
      <div>
        <strong>Pré-visualização do cadastro</strong>
        <small>Revise os dados e anexos em formato de relatório antes do envio final.</small>
      </div>
      <button type="button" class="admission-review-modal__close" (click)="closeReviewModal()">×</button>
    </header>

    <div class="admission-review-modal__body">
      <article class="admission-review-report">
        <aside class="admission-review-report__sidebar">
          <div class="admission-review-report__sidebar-brand">
            <img src="../../../assets/MIV/brand/versao 1.png" alt="ControlPS" />
          </div>

          <div class="admission-review-report__sidebar-photo" *ngIf="photoPreviewUrl; else reviewPhotoPlaceholder">
            <img [src]="photoPreviewUrl" alt="Foto do colaborador" />
          </div>
          <ng-template #reviewPhotoPlaceholder>
            <div class="admission-review-report__sidebar-photo admission-review-report__sidebar-photo--placeholder">
              <span>{{ initialsFromName(admissions.header.full_name) }}</span>
            </div>
          </ng-template>

          <div class="admission-review-report__sidebar-identity">
            <strong>{{ admissions.header.full_name || '-' }}</strong>
            <span>
              <mat-icon>badge</mat-icon>
              {{ admissions.header.cpf || '-' }}
            </span>
            <span>
              <mat-icon>mail</mat-icon>
              {{ admissions.header.personal_email || '-' }}
            </span>
          </div>

        </aside>

        <div class="admission-review-report__content">
          <header class="admission-review-report__head">
            <h3>PRÉ-VISUALIZAÇÃO</h3>
            <p>Colaborador: <strong>{{ admissions.header.full_name || '-' }}</strong></p>
            <div class="admission-review-report__head-meta">
              <span>Gerado em: {{ currentDateLabel }} às {{ currentTimeLabel }}</span>
              <span
                class="admission-review-report__status-pill"
                [class.ready]="isAdmissionReadyForSubmit && !isAdmissionUnderReview"
                [class.sent]="isAdmissionUnderReview">
                Status: {{ reviewStatusLabel() }}
              </span>
            </div>
          </header>

          <section class="admission-review-report__section">
            <h4><mat-icon>badge</mat-icon>Identificação</h4>
            <div class="admission-review-grid admission-review-grid--double">
              <div class="admission-review-field admission-review-field--document">
                <p><span>Nome:</span> <strong>{{ admissions.header.full_name || '-' }}</strong></p>
                <p><span>CPF:</span> <strong>{{ admissions.header.cpf || '-' }}</strong></p>
                <p><span>RG:</span> <strong>{{ displayDetailValue('rg') }}</strong></p>
              </div>
              <div class="admission-review-field admission-review-field--document">
                <p><span>Data de nascimento:</span> <strong>{{ displayDetailValue('birth_date') }}</strong></p>
                <p><span>Estado civil:</span> <strong>{{ displayDetailValue('marital_status') }}</strong></p>
              </div>
            </div>
          </section>

          <section class="admission-review-report__section">
            <div class="admission-review-grid admission-review-grid--double">
              <div class="admission-review-field admission-review-field--document">
                <h5><mat-icon>school</mat-icon>Informações pessoais</h5>
                <p><span>Escolaridade:</span> <strong>{{ displayDetailValue('education_level') }}</strong></p>
                <p><span>Telefone:</span> <strong>{{ displayDetailValue('phone') }}</strong></p>
                <p><span>E-mail:</span> <strong>{{ admissions.header.personal_email || '-' }}</strong></p>
              </div>
              <div class="admission-review-field admission-review-field--document">
                <h5><mat-icon>pin_drop</mat-icon>Endereço</h5>
                <p><span>Cidade / UF:</span> <strong>{{ displayDetailValue('city') }}{{ displayDetailValue('state') !== '-' ? ' / ' + displayDetailValue('state') : '' }}</strong></p>
                <p><span>CEP:</span> <strong>{{ displayDetailValue('cep') }}</strong></p>
                <p><span>Rua / Número:</span> <strong>{{ displayDetailValue('street') }}{{ displayDetailValue('number') !== '-' ? ', ' + displayDetailValue('number') : '' }}</strong></p>
              </div>
            </div>
          </section>

          <section class="admission-review-report__section">
            <h4><mat-icon>attach_file</mat-icon>Anexos enviados</h4>
            <div class="admission-review-attachments" *ngIf="totalUploadedDocuments; else noReviewAttachments">
              <ng-container *ngFor="let category of documentCategories">
                <button
                  type="button"
                  class="admission-review-attachment-row"
                  *ngFor="let file of documentsByCategory[category.key]"
                  (click)="openDocumentPreview(file)">
                  <span class="admission-review-attachment-row__check"><mat-icon>check_circle</mat-icon></span>
                  <span class="admission-review-attachment-row__thumb" [class.pdf]="isPdfDocument(file)" [class.file]="!isImageDocument(file)">
                    <img *ngIf="isImageDocument(file)" [src]="documentUrl(file)" [alt]="file.name" />
                    <span *ngIf="!isImageDocument(file)">PDF</span>
                  </span>
                  <span class="admission-review-attachment-row__meta">
                    <strong>{{ file.name }}</strong>
                    <small>{{ category.label }} • {{ formatFileSize(file.file_size) }}</small>
                  </span>
                </button>
              </ng-container>
            </div>
            <ng-template #noReviewAttachments>
              <p class="admission-review-empty">Nenhum anexo enviado.</p>
            </ng-template>
          </section>

          <footer class="admission-review-report__foot">
            Pré-visualização gerada automaticamente pelo ControlPS • ControlDP
          </footer>
        </div>
      </article>
    </div>

    <footer class="admission-review-modal__actions">
      <button type="button" class="admission-review-cancel" (click)="closeReviewModal()">Cancelar</button>
      <button
        type="button"
        class="admission-review-submit"
        [disabled]="!isAdmissionReadyForSubmit || isAdmissionUnderReview || submissionFeedbackState === 'loading'"
        (click)="submitAdmissionForReview()">
        {{ isAdmissionUnderReview ? 'Enviado' : 'Enviar' }}
      </button>
    </footer>
  </div>
</section>

<section class="admission-submit-feedback" *ngIf="submissionFeedbackState !== 'idle'">
  <div class="admission-submit-feedback__content" [ngSwitch]="submissionFeedbackState">
    <ng-container *ngSwitchCase="'loading'">
      <div class="admission-submit-feedback__spinner">
        <img src="../../../assets/MIV/brand/versao 1.png" alt="ControlPS">
      </div>
      <strong>Enviando dados para análise...</strong>
      <small>Aguarde enquanto finalizamos seu cadastro.</small>
    </ng-container>
    <ng-container *ngSwitchCase="'success'">
      <div class="admission-submit-feedback__icon admission-submit-feedback__icon--success">✓</div>
      <strong>Dados enviados com sucesso!</strong>
      <small>Seu cadastro está aguardando análise do time de DP.</small>
    </ng-container>
    <ng-container *ngSwitchCase="'error'">
      <div class="admission-submit-feedback__icon admission-submit-feedback__icon--error">!</div>
      <strong>Não foi possível concluir o envio</strong>
      <small>{{ submissionFeedbackMessage || 'Tente novamente em alguns instantes.' }}</small>
      <button type="button" class="admission-submit-feedback__action-btn" (click)="dismissSubmissionFeedback()">
        Entendi
      </button>
    </ng-container>
  </div>
</section>
